/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import monitoringService from 'infrastructure/serviceHandlers/Monitoring/Monitoring';
import { getTrailCamPlans } from 'services/api/trailCamApi';
import { TPlanList } from 'typings';
import { TTrailPlanState } from 'typings/trailTypes';

export const fetchTrailPlans = createAsyncThunk(
  'spaces/fetchTrailPlans',
  async (payload: { country: string; sku_category: string }, thunkAPI) => {
    try {
      const response = await getTrailCamPlans(payload);
      return response.data;
    } catch (error) {
      monitoringService.captureException(error, {
        tags: {
          feature: 'fetchTrailPlans',
          error_type: 'api_error'
        },
        extra: {
          payload
        }
      });
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialPlanState: TTrailPlanState = {
  trailPlanList: [],
  isLoading: false
};

export const allPlanSlice = createSlice({
  name: 'allPlans',
  initialState: initialPlanState,
  reducers: {
    clearTrailPlansData: (state) => {
      state.trailPlanList = [];
    },
    updateTrailPlansData: (state, action) => {
      state.trailPlanList = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrailPlans.fulfilled, (state, action) => {
        state.isLoading = false;
        state.trailPlanList = action.payload as TPlanList[];
      })
      .addCase(fetchTrailPlans.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTrailPlans.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

// Action creators are generated for each case reducer function
export const { clearTrailPlansData, updateTrailPlansData } =
  allPlanSlice.actions;

export default allPlanSlice.reducer;
